globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
//  Trigger another update
export * from './context';
export * from './constants';
export * from './components';
export * from './hook/use-is-employer-an-admin';
export * from './hook/use-employer-user-info-query';